import React from 'react';

export default function SettingsIcon(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 21.7 21.7"
      style={{ enableBackground: 'new 0 0 21.7 21.7' }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        id="XMLID_2_"
        d="M11.8,1c0.2,0,0.3,0.1,0.3,0.3l0.4,2.1l0.1,0.6l0.5,0.2c0.3,0.1,0.5,0.2,0.8,0.3l0.5,0.2l0.5-0.3
      	l1.8-1.2c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0.1l1.3,1.3c0.1,0.1,0.1,0.3,0,0.4l-1.2,1.8L17,7.2l0.2,0.5
      	c0.1,0.3,0.2,0.5,0.3,0.8L17.7,9l0.6,0.1l2.1,0.4c0.2,0,0.3,0.2,0.3,0.3v1.8c0,0.2-0.1,0.3-0.3,0.3l-2.1,0.4l-0.6,0.1l-0.2,0.5
      	c-0.1,0.3-0.2,0.5-0.3,0.8L17,14.4l0.3,0.5l1.2,1.8c0.1,0.1,0.1,0.3,0,0.4l-1.3,1.3c-0.1,0.1-0.2,0.1-0.3,0.1c0,0-0.1,0-0.2-0.1
      	l-1.8-1.2L14.5,17l-0.5,0.2c-0.3,0.1-0.5,0.2-0.8,0.3l-0.5,0.2l-0.1,0.6l-0.4,2.1c0,0.2-0.2,0.3-0.3,0.3H9.9c-0.2,0-0.3-0.1-0.3-0.3
      	l-0.4-2.1L9,17.7l-0.5-0.2c-0.3-0.1-0.5-0.2-0.8-0.3L7.2,17l-0.5,0.3L5,18.5c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1l-1.3-1.3
      	c-0.1-0.1-0.1-0.3,0-0.4l1.2-1.8l0.3-0.5l-0.2-0.5c-0.1-0.3-0.2-0.5-0.3-0.8l-0.2-0.5l-0.6-0.1l-2.1-0.4c-0.2,0-0.3-0.2-0.3-0.3V9.9
      	c0-0.2,0.1-0.3,0.3-0.3l2.1-0.4L3.9,9l0.2-0.5C4.2,8.2,4.3,8,4.4,7.7l0.2-0.5L4.4,6.7L3.2,5c-0.1-0.1-0.1-0.3,0-0.4l1.3-1.3
      	c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0.1l1.8,1.2l0.5,0.3l0.5-0.2C8,4.3,8.2,4.2,8.5,4.1L9,3.9l0.1-0.6l0.4-2.1
      	C9.6,1.1,9.7,1,9.9,1H11.8 M11.8,0H9.9C9.3,0,8.7,0.5,8.6,1.1L8.2,3.2C7.9,3.3,7.6,3.4,7.3,3.5L5.5,2.4C5.3,2.2,5,2.1,4.8,2.1
      	c-0.3,0-0.7,0.1-1,0.4L2.5,3.8C2.1,4.3,2,5,2.4,5.5l1.2,1.8C3.4,7.6,3.3,7.9,3.2,8.2L1.1,8.6C0.5,8.7,0,9.3,0,9.9v1.8
      	c0,0.6,0.5,1.2,1.1,1.3l2.1,0.4c0.1,0.3,0.2,0.6,0.4,0.9l-1.2,1.8c-0.4,0.5-0.3,1.3,0.2,1.7l1.3,1.3c0.3,0.3,0.6,0.4,1,0.4
      	c0.3,0,0.5-0.1,0.8-0.2l1.8-1.2c0.3,0.1,0.6,0.3,0.9,0.4l0.4,2.1c0.1,0.6,0.7,1.1,1.3,1.1h1.8c0.6,0,1.2-0.5,1.3-1.1l0.4-2.1
      	c0.3-0.1,0.6-0.2,0.9-0.4l1.8,1.2c0.2,0.2,0.5,0.2,0.7,0.2c0.4,0,0.7-0.1,1-0.4l1.3-1.3c0.5-0.5,0.5-1.2,0.2-1.7l-1.2-1.8
      	c0.1-0.3,0.3-0.6,0.4-0.9l2.1-0.4c0.6-0.1,1.1-0.7,1.1-1.3V9.9c0-0.6-0.5-1.2-1.1-1.3l-2.1-0.4c-0.1-0.3-0.2-0.6-0.4-0.9l1.2-1.8
      	c0.4-0.5,0.3-1.3-0.2-1.7l-1.3-1.3c-0.3-0.3-0.6-0.4-1-0.4c-0.3,0-0.5,0.1-0.7,0.2l-1.8,1.2c-0.3-0.1-0.6-0.3-0.9-0.4l-0.4-2.1
      	C13,0.5,12.4,0,11.8,0L11.8,0z"
      />
      <path
        id="XMLID_3_"
        d="M11,8.1c1.5,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8S9.4,8.1,11,8.1 M11,7.1
      	c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8S13.1,7.1,11,7.1L11,7.1z"
      />
    </svg>
  );
}
